import { AppType, getAppType, NATIVESDK_UNDEFINED_MSG } from "./nativeHelpers";
import * as logger from "../../utils/logger";
import errorFilter from "../error.filter";
import { handleJSNative } from "../error";

function nativeSpeakUsingNativeSDK(phrase: string, speechRate: number, speechLang: string, appTypeString: string) {
    if (!window.geotabModules) {
        logger.error(logger.Source.NATIVE, `nativeSpeak: ${ NATIVESDK_UNDEFINED_MSG } (AppType: ${ appTypeString })`);
        return;
    }
    window.geotabModules.speech.nativeSpeak({ text: phrase, rate: speechRate, lang: speechLang }, (error) => {
        if (error && !errorFilter.isIgnored(error)) {
            logger.error(logger.Source.NATIVE, `nativeSpeak error: ${ error.message }`);
        } else {
            logger.log(logger.Source.NATIVE, `nativeSpeak: Spoke: "${ phrase }" (AppType: ${ appTypeString })`);
        }
    });
}

function nativeSpeakUsingCordova(phrase: string, speechRate: number, speechLang: string, appTypeString: string) {
    let utteranceClass = (self !== top) ? window.cordova.SpeechSynthesisUtterance : window.SpeechSynthesisUtterance;
    let speechPlugin = (self !== top) ? window.cordova.speechSynthesis : window["speechSynthesis"];
    if (utteranceClass) {
        let u = new utteranceClass();
        u.text = phrase;
        u.rate = speechRate;
        u.lang = speechLang;
        speechPlugin && speechPlugin.speak(u);
        logger.log(logger.Source.NATIVE, `nativeSpeak: Spoke: "${ phrase }" (AppType: ${ appTypeString })`);
    }
}

/**
 * Speak the text phrase
 */
 export function nativeSpeak (phrase: string, rate?: number | null, lang?: string | null): void {
    let speechRate = rate || 0.9;
    let speechLang = (lang === "bp" ? "pt-br" : lang) || "en";
    let appType = getAppType();
    let appTypeString = AppType[appType];
    logger.log(logger.Source.NATIVE, `nativeSpeak: Request to speak: "${ phrase }" (AppType: ${ appTypeString })`);
    try {
        switch (appType) {
            case AppType.CordovaApp: {
                // Shell passes down into a "cordova" object inside of "contentWindow" because otherwise it suffers from
                // a EventTarget super class from trying to use the "Web Speech API" instead of Cordova plugin's object defn
                nativeSpeakUsingCordova(phrase, speechRate, speechLang, appTypeString);
                break;
            }
            case AppType.NativeSdk:
                nativeSpeakUsingNativeSDK(phrase, speechRate, speechLang, appTypeString);
                break;
            case AppType.WebApp:
            default:
                break;
        }
    } catch (error) {
        handleJSNative(error instanceof Error ? error : new Error(error), true, "nativeUnhandledException");
    }
}

export let speakSilence = function (ms) {
    try {
        switch (getAppType()) {
            case AppType.CordovaApp: {
                if (window.device.platform === "iOS") {
                    return;
                }
                let speechPlugin = (self !== top) ? window.cordova.speechSynthesis : window["speechSynthesis"];
                speechPlugin && speechPlugin.silence(ms);
                break;
            }
            case AppType.NativeSdk:
                break;
            case AppType.WebApp:
            default:
                break;
        }
    } catch (error) {
        handleJSNative(error instanceof Error ? error : new Error(error), true, "nativeUnhandledException");
    }
};
